import React from 'react';

const Description = ({ className, onChange, value }) => (
  <div className={className}>
    <label className="d-b" htmlFor="description" type="text" name="description">
      {t('common.description')}
    </label>
    <textarea
      name="description"
      aria-label="Description Input Field"
      className="Textarea mh-125 w-fill"
      id="description"
      onChange={onChange}
      placeholder={t('in_person_training.events.form.placeholders.description')}
      value={value}
    />
  </div>
);

export default Description;
